<ng-container *ngIf="CompanyData">
  <div class="company-card shadow-sm overflow-hidden">

    <!-- Top Section -->
    <div class="text-center p-4"
      style="background:transparent; color:var(--bs-primary); border:1px solid var(--bs-primary);">

      <div class="rounded-circle d-inline-flex align-items-center justify-content-center"
        style="width:70px; height:70px; background:white; border:4px solid #E5E5E5;">
        <i class="bi bi-building fs-2 text-primary"></i>
      </div>

      <h5 class="mt-3 mb-0">
        <ng-container *ngIf="!editingField; else editName">
          {{ CompanyData.cName }}
          <i class="bi bi-copy ms-2" style="color: #797979; cursor:pointer; font-size: 18px;"
            (click)="copyData(CompanyData.cName)">
          </i>

        </ng-container>
        <ng-template #editName>
          <input class="form-control text-center" [(ngModel)]="CompanyData.cName">
        </ng-template>
      </h5>
    </div>

    <div class="p-2 pt-3 pb-2">

      <!-- Contact Person -->
      <div class="d-flex align-items-center mb-1">
        <div class="icon-bg me-2">
          <i class="bi bi-person-circle fs-5 text-primary"></i>
        </div>

        <span class="flex-grow-1 d-flex align-items-center">
          <ng-container *ngIf="!editingField; else editPerson">
            <span *ngIf="!CompanyData.contactPerson" class="text-muted fst-italic" style="font-size:12px">No contact person</span>
            {{ CompanyData.contactPerson }}
            <i *ngIf="CompanyData.contactPerson" class="bi bi-copy ms-2" style="color: #797979; cursor:pointer; font-size: 16px;"
              (click)="copyData(CompanyData.contactPerson)">
            </i>


          </ng-container>

          <ng-template #editPerson>
            <input class="form-control form-control-sm" [(ngModel)]="CompanyData.contactPerson">
          </ng-template>
        </span>
      </div>

      <form #companyForm="ngForm">
        <!-- Email -->
        <div class="d-flex align-items-center mb-1">
          <div class="icon-bg me-2">
            <i class="bi bi-envelope fs-5 text-primary"></i>
          </div>

          <span class="flex-grow-1 d-flex align-items-center">
            <ng-container *ngIf="!editingField; else editEmail">
              <span *ngIf="!CompanyData.email" class="text-muted fst-italic" style="font-size:12px">No email</span>
              {{ CompanyData.email }}
              <i *ngIf="CompanyData.email" class="bi bi-copy ms-2" style="color: #797979; cursor:pointer; font-size: 16px;"
                (click)="copyData(CompanyData.email)">
              </i>

            </ng-container>

            <ng-template #editEmail>
              <div class="w-100">
                <input class="form-control form-control-sm" type="email" name="email"
                  pattern="^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$" #emailRef="ngModel"
                  [(ngModel)]="CompanyData.email" (input)="emailBlurred = false" (blur)="emailBlurred = true"
                  [class.is-invalid]="emailRef.invalid && CompanyData.email && (emailBlurred || submitted)">

                <small class="text-danger" *ngIf="emailRef.invalid && CompanyData.email && (emailBlurred || submitted)">
                  Enter valid Email
                </small>
              </div>
            </ng-template>



          </span>
        </div>

        <!-- Phone -->
        <div class="d-flex align-items-center mb-1">
          <div class="icon-bg me-2">
            <i class="bi bi-telephone fs-5 text-primary"></i>
          </div>

          <span class="flex-grow-1 d-flex align-items-center">
            <ng-container *ngIf="!editingField; else editPhone">
              <span *ngIf="!CompanyData.phone" class="text-muted fst-italic" style="font-size:12px">No phone</span>
              {{ CompanyData.phone }}
              <i *ngIf="CompanyData.phone" class="bi bi-copy ms-2" style="color: #797979; cursor:pointer; font-size: 16px;"
                (click)="copyData(CompanyData.phone)">
              </i>
            </ng-container>

            <ng-template #editPhone>
              <div class="w-100 d-flex flex-column">
                <input class="form-control form-control-sm" type="tel" name="phone" pattern="^[0-9]{10}$"
                  #phoneRef="ngModel" [(ngModel)]="CompanyData.phone" (input)="phoneBlurred = false"
                  (blur)="phoneBlurred = true"
                  [class.is-invalid]="phoneRef.invalid && CompanyData.phone && (phoneBlurred || submitted)">

                <small class="text-danger mt-1" *ngIf="phoneRef.invalid && CompanyData.phone && (phoneBlurred || submitted)">
                  Enter valid Phone
                </small>
              </div>
            </ng-template>


          </span>
        </div>
      </form>


      <!-- Address -->
      <div class="d-flex align-items-center mb-1">
        <div class="icon-bg me-2">
          <i class="bi bi-geo-alt fs-5 text-primary"></i>
        </div>

        <span class="flex-grow-1 d-flex align-items-center">
          <ng-container *ngIf="!editingField; else editAddress">
            <span *ngIf="!CompanyData.cAddress" class="text-muted fst-italic" style="font-size:12px">No address</span>
            {{ CompanyData.cAddress }}

            <i *ngIf="CompanyData.cAddress" class="bi bi-copy ms-2" style="color: #797979; cursor:pointer; font-size: 16px;"
              (click)="copyData(CompanyData.cAddress)">
            </i>
          </ng-container>

          <ng-template #editAddress>
            <textarea class="form-control form-control-sm" rows="2" [(ngModel)]="CompanyData.cAddress"></textarea>
          </ng-template>
        </span>
      </div>



      <!-- Tags -->
      <div class="mt-3">
        <ng-container *ngIf="!editingField; else editTags">
          <span class="d-flex align-items-center gap-1 ">
            <i class="bi bi-link-45deg" style="color:#797979;"></i>
            <span *ngIf="!CompanyData.category" class="text-muted fst-italic" style="font-size:12px">No category</span>
            {{ CompanyData.category }}
          </span>

          <span class="d-flex align-items-center gap-1 ">
            <i class="bi bi-link-45deg" style="color:#797979;"></i>
            <span *ngIf="!CompanyData.subCategory" class="text-muted fst-italic" style="font-size:12px">No sub-category</span>
            {{ CompanyData.subCategory }}
          </span>
        </ng-container>

        <ng-template #editTags>
          <ng-select class="mb-1" [items]="(categoryService.Categories$ | async) ?? []"
            bindLabel="categoryName" bindValue="categoryName" placeholder="Select Category" appendTo="body"
            [(ngModel)]="CompanyData.category" (change)="onCategoryChange($event)">
          </ng-select>

          <ng-select [items]="(categoryService.SubCategories$ | async) ?? []"
            bindLabel="subCategoryName" bindValue="subCategoryName" placeholder="Select Sub Category" appendTo="body"
            [(ngModel)]="CompanyData.subCategory">
          </ng-select>
        </ng-template>
      </div>

      <!-- Buttons -->
      <div class="edit-buttons mt-3 d-flex justify-content-end gap-2">

        <!-- Edit -->
        <div class="edit-btn text" *ngIf="!editingField" (click)="editField()">
          <i class="bi bi-pencil-fill" style="color: #d9d9d9;"></i>
        </div>

        <!-- Save & Cancel -->
        <ng-container *ngIf="editingField">
          <div class="edit-btn" (click)="saveField(companyForm)">
            <i class="bi bi-check-lg"></i>
          </div>


          <div class="edit-btn" (click)="cancelEdit()">
            <i class="bi bi-x-lg"></i>
          </div>
        </ng-container>

      </div>

    </div>
  </div>
</ng-container>